import { useContext } from 'react';
import QueryParamsContext  from './QueryParamsProvider';

const useQueryParams = () => {
    return useContext(QueryParamsContext);
};

export default useQueryParams;